import React from "react";
import "./HomePageHeader.css";
import PhoneIcon from "@material-ui/icons/Phone";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import MailIcon from "@material-ui/icons/Mail";
import TelegramIcon from "@material-ui/icons/Telegram";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import InstagramIcon from "@material-ui/icons/Instagram";
import FlightTakeoffIcon from "@material-ui/icons/FlightTakeoff";
import { Link } from "react-router-dom";

function HomePageHeader() {
  return (
    <div className="header">
      <div className="header_top">
        <div className="header_top_left">
        <a href="/" className="homelink">
        <p>
            Travel 
          <span>  Uzbekistan</span>
            <FlightTakeoffIcon />
          </p>
        </a>
          <a href="" className="link">
            <PhoneIcon />
            <p>+99111223344</p>
          </a>
          <a href="" className="link">
            <MailIcon />
            <p>example.mail.com</p>
          </a>
          <a href="" className="link">
            <LocationOnIcon />
            <p>Tashkent, Uzbekistan</p>
          </a>
        </div>
        <div className="header_top_right">
          <div className="social">
            <a href="">
              <TelegramIcon />
            </a>
          </div>
          <div className="social">
            <a href="">
              <FacebookIcon />
            </a>
          </div>
          <div className="social">
            <a href="">
              <InstagramIcon />
            </a>
          </div>
          <div className="social">
            <a href="">
              <TwitterIcon />
            </a>
          </div>
        </div>
      </div>

        <div className="header_bottom">
          <ul>
            <li>
              <Link to="/homepage">Home</Link>
            </li>
            <li>
              <Link to="/homepage/cities">Cities</Link>
            </li>
            <li>
              <Link to="/homepage/gallery">Gallery</Link>
            </li>
            <li>
              <Link to="/homepage/news">News</Link>
            </li>
            <li>
              <Link to="/homepage/about">About us</Link>
            </li>
          </ul>
        </div>

       
    </div>
  );
}

export default HomePageHeader;
